import React, { useContext } from "react";
import { HotelContext } from "../../context/HotelContext";
import LineChartComponent_simple from "../../component/Linecomponent_simple";
import { GraphCard, SummaryStatCard, SummaryStatCardsRow } from "../../components/v2/cards";
import { translate } from "../../utils/Translation";

export const DashboardSummaryStatCard = SummaryStatCard;

export const DashboardSummaryCardsRow = ({ cards = [] }) => {
  return (
    <SummaryStatCardsRow
      cards={cards}
      className="summary-stat-cards-row--grid summary-stat-cards-row--cols-3"
    />
  );
};

export const EconomiesTrendCard = ({
  loading,
  hasError,
  noDataAvailable,
  chartData,
  selectedYear,
  onPreviousYear,
  onNextYear,
  luniShowerOnly = false,
  hasWaterOption = true,
}) => {
  const { lang } = useContext(HotelContext);

  return (
    <GraphCard
      title={translate("v2_dashboard_chart_monthly_title", lang)}
      subtitle={translate("v2_dashboard_chart_monthly_subtitle", lang)}
      legendTitle={translate("v2_dashboard_chart_legend", lang)}
      legendDotColor="#FAA54B"
      showYearSelector={true}
      year={selectedYear}
      onPreviousYear={onPreviousYear}
      onNextYear={onNextYear}
      className="dashboard-v2__chart"
      contentClassName="dashboard-v2__chart-content"
    >
      {loading ? (
        <div className="dashboard-v2__loader">
          <p>{translate("v2_loading_data", lang)}</p>
        </div>
      ) : hasError ? (
        <div className="dashboard-v2__loader">
          <p>{translate("v2_error_load_data_short", lang)}</p>
        </div>
      ) : noDataAvailable ? (
        <div className="dashboard-v2__loader">
          <p>{translate("v2_data_not_yet_available", lang)}</p>
        </div>
      ) : chartData && chartData.length > 0 ? (
        <div className="dashboard-v2__chart-wrapper">
          <LineChartComponent_simple
            data={chartData}
            luniShowerOnly={luniShowerOnly}
            hasWaterOption={hasWaterOption}
          />
        </div>
      ) : (
        <div className="dashboard-v2__loader">
          <p>{translate("v2_no_data_period", lang)}</p>
        </div>
      )}
    </GraphCard>
  );
};

export const DeclinedServicesCard = ({ servicesDeclinedLoading, servicesDeclined, bedIcon, onOpenAllRooms }) => {
  const { lang } = useContext(HotelContext);

  return (
    <div className="dashboard-v2__card-list">
      <div className="dashboard-v2__card-list-header">{translate("v2_dashboard_declined_rooms", lang)}</div>
      <div className="dashboard-v2__card-list-sub">{translate("v2_dashboard_declined_recent", lang)}</div>
      {servicesDeclinedLoading ? (
        <div className="dashboard-v2__loader">
          <p>{translate("v2_loading", lang)}</p>
        </div>
      ) : servicesDeclined.length === 0 ? (
        <div className="dashboard-v2__loader">
          <p>{translate("v2_dashboard_no_declined", lang)}</p>
        </div>
      ) : (
        servicesDeclined.map((item, idx) => (
          <div key={idx} className="dashboard-v2__list-row">
            <div className="dashboard-v2__list-left">
              <img src={bedIcon} alt={translate("Room_nb", lang)} className="dashboard-v2__list-icon-img dashboard-v2__list-icon-img--room" />
              <span className="dashboard-v2__list-room">{item.room}</span>
            </div>
            <div className="dashboard-v2__list-right">
              <img src={item.iconSrc} alt="Action" className="dashboard-v2__list-icon-img dashboard-v2__list-icon-img--action" />
              <span className="dashboard-v2__list-action dashboard-v2__list-action--italic">{item.action}</span>
            </div>
          </div>
        ))
      )}
      <div className="dashboard-v2__list-footer">
        <button className="dashboard-v2__pill-btn" onClick={onOpenAllRooms}>
          {translate("v2_dashboard_all_rooms", lang)}
        </button>
      </div>
    </div>
  );
};

export const ActiveStaysCard = ({ recentActionsLoading, recentActions, bedIcon }) => {
  const { lang } = useContext(HotelContext);

  return (
    <div className="dashboard-v2__card-list">
      <div className="dashboard-v2__card-list-header">{translate("v2_dashboard_active_stays", lang)}</div>
      <div className="dashboard-v2__card-list-sub">{translate("v2_dashboard_active_stays_sub", lang)}</div>
      {recentActionsLoading ? (
        <div className="dashboard-v2__loader">
          <p>{translate("v2_loading", lang)}</p>
        </div>
      ) : recentActions.length === 0 ? (
        <div className="dashboard-v2__loader">
          <p>{translate("v2_dashboard_no_recent_action", lang)}</p>
        </div>
      ) : (
        recentActions.map((item, idx) => (
          <div key={idx} className="dashboard-v2__list-row">
            <div className="dashboard-v2__list-left">
              <img src={bedIcon} alt={translate("Room_nb", lang)} className="dashboard-v2__list-icon-img dashboard-v2__list-icon-img--room" />
              <span className="dashboard-v2__list-room">{item.room}</span>
            </div>
            <div className="dashboard-v2__list-right">
              <img src={item.iconSrc} alt="Action" className="dashboard-v2__list-icon-img dashboard-v2__list-icon-img--action" />
              <span className="dashboard-v2__list-action dashboard-v2__list-action--italic">{item.action}</span>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export const TopActionsCard = ({ topActionsLoading, topActions, iconForActType }) => {
  const { lang } = useContext(HotelContext);

  return (
    <div className="dashboard-v2__card-list dashboard-v2__card-list--tinted">
      <div className="dashboard-v2__card-list-header">{translate("v2_dashboard_top_actions", lang)}</div>
      <div className="dashboard-v2__card-list-sub">{translate("v2_dashboard_top_actions_sub", lang)}</div>
      {topActionsLoading ? (
        <div className="dashboard-v2__loader">
          <p>{translate("v2_loading", lang)}</p>
        </div>
      ) : topActions.length === 0 ? (
        <div className="dashboard-v2__loader">
          <p>{translate("v2_no_data", lang)}</p>
        </div>
      ) : (
        topActions.map((item, idx) => (
          <div key={item.actId || idx} className="dashboard-v2__list-row">
            <div className="dashboard-v2__list-left">
              <img src={iconForActType(item.actType)} alt="Action" className="dashboard-v2__list-icon-img dashboard-v2__list-icon-img--action" />
              <span className="dashboard-v2__top-label">{item.label}</span>
            </div>
            <div className="dashboard-v2__list-right">
              <div className="dashboard-v2__top-metric">
                <div className="dashboard-v2__top-percent">{item.percentage}%</div>
                <div className="dashboard-v2__top-ratio">({item.ratio})</div>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export const RecentReviewsCard = ({ recentReviewsLoading, recentReviews }) => {
  const { lang } = useContext(HotelContext);

  return (
    <div className="dashboard-v2__card-list dashboard-v2__card-list--tinted">
      <div className="dashboard-v2__card-list-header">{translate("v2_dashboard_recent_reviews", lang)}</div>
      <div className="dashboard-v2__card-list-sub">{translate("v2_dashboard_recent_reviews_sub", lang)}</div>
      {recentReviewsLoading ? (
        <div className="dashboard-v2__loader">
          <p>{translate("v2_loading", lang)}</p>
        </div>
      ) : recentReviews.length === 0 ? (
        <div className="dashboard-v2__loader">
          <p>{translate("v2_dashboard_no_recent_review", lang)}</p>
        </div>
      ) : (
        recentReviews.map((r) => (
          <div key={r.id} className="dashboard-v2__review-row">
            <div className="dashboard-v2__review-avatar" />
            <div className="dashboard-v2__review-content">
              <div className="dashboard-v2__review-author">{r.author}</div>
              <div className="dashboard-v2__review-text">{r.text}</div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};
